import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { BaseComponent } from './base.component';
import { TutorialStepsComponent } from './tutorial-steps.component';

@Component({
    selector: 'app-noop-component',
    template: ''
})
export class NoopComponent {
}

const routes: Routes = [
    {
        path: 'sim',
        component: BaseComponent,
        children: [
            {
                path: 'tutorial',
                component: TutorialStepsComponent,
                data: {state: true}
            }
        ]
    }, {
        path: 'sim/survival',
        component: NoopComponent
    }, {
        path: 'sim/custom',
        component: NoopComponent
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
    declarations: [ NoopComponent ]
})
export class SimulationModeRoutingModule { }
